// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as DeliveryNoteVm from "../../view-model/DeliveryNoteVm.bs.js";
import * as MuiTabs$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/tabs/MuiTabs.bs.js";

function getTabsList(param) {
  return {
          hd: {
            tabId: /* Edit */0,
            label: {
              TAG: /* Text */0,
              _0: "Edit Order"
            },
            icon: null,
            disabled: false,
            tooltip: undefined
          },
          tl: {
            hd: {
              tabId: /* Cancel */1,
              label: {
                TAG: /* Text */0,
                _0: "Cancel Order"
              },
              icon: null,
              disabled: false,
              tooltip: undefined
            },
            tl: /* [] */0
          }
        };
}

function getTabsList__DeliveryNote(country) {
  return {
          hd: {
            tabId: /* Edit */0,
            label: {
              TAG: /* Text */0,
              _0: "Edit Order"
            },
            icon: null,
            disabled: false,
            tooltip: undefined
          },
          tl: {
            hd: {
              tabId: /* Cancel */1,
              label: {
                TAG: /* Text */0,
                _0: "Cancel Order"
              },
              icon: null,
              disabled: false,
              tooltip: undefined
            },
            tl: {
              hd: {
                tabId: /* DeliveryNote */2,
                label: {
                  TAG: /* Text */0,
                  _0: DeliveryNoteVm.getDNName(country)
                },
                icon: null,
                disabled: false,
                tooltip: undefined
              },
              tl: /* [] */0
            }
          }
        };
}

var Tabs = {
  getTabsList: getTabsList,
  getTabsList__DeliveryNote: getTabsList__DeliveryNote
};

function EditOrderSidebarHeader(Props) {
  var crn = Props.crn;
  var active_edit_order_tab = Props.active_edit_order_tab;
  var changeEditOrderTab = Props.changeEditOrderTab;
  var match = React.useState(function () {
        return active_edit_order_tab;
      });
  var currentTab = match[0];
  var country = CountryContext.useContext(undefined).country;
  var tabs;
  tabs = country.TAG === /* BD */2 ? getTabsList(undefined) : getTabsList__DeliveryNote(country);
  React.useEffect((function () {
          switch (currentTab) {
            case /* Edit */0 :
                Curry._1(changeEditOrderTab, (function (param) {
                        return /* EditOrder */0;
                      }));
                break;
            case /* Cancel */1 :
                Curry._1(changeEditOrderTab, (function (param) {
                        return /* CancelOrder */1;
                      }));
                break;
            case /* DeliveryNote */2 :
                Curry._1(changeEditOrderTab, (function (param) {
                        return /* DeliveryNote */2;
                      }));
                break;
            
          }
          
        }), [currentTab]);
  return React.createElement("div", {
              className: "c-edit-order-header"
            }, React.createElement("h1", {
                  className: "crn-number"
                }, crn), React.createElement(MuiTabs$Catalyst.make, {
                  tabs: tabs,
                  activeTab: currentTab,
                  setActiveTab: match[1]
                }));
}

var make = EditOrderSidebarHeader;

export {
  Tabs ,
  make ,
  
}
/* react Not a pure module */
